export const getVisibleLabels = (labels: string[]) => {
    const maxVisibleLabels = 8;

    return labels.length <= maxVisibleLabels
        ? labels
        : labels.slice(0, maxVisibleLabels);
};
